import { supabase } from '../config/supabase';

/**
 * Récupère le token d'authentification de l'utilisateur
 */
const getAuthToken = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  
  if (!session?.access_token) {
    throw new Error('Utilisateur non connecté');
  }
  
  return session.access_token;
};

/**
 * Récupère un événement par son ID via la Edge Function get-event-by-id
 * @param {string} eventId - L'ID de l'événement
 * @returns {Promise<Object>} L'événement avec ses relations
 */
export const getEventById = async (eventId) => {
  try {
    const authToken = await getAuthToken();
    const url = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/get-event-by-id`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
        'x-requested-with': 'XMLHttpRequest'
      },
      body: JSON.stringify({ eventId })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error(`[eventService] Erreur lors de la récupération de l'événement ${eventId}:`, error);
    throw error;
  }
};

/**
 * Récupère plusieurs événements par leurs IDs en parallèle
 * @param {string[]} eventIds - Tableau d'IDs d'événements
 * @returns {Promise<Object[]>} Tableau d'événements avec leurs relations
 */
export const getEventsByIds = async (eventIds) => {
  if (!eventIds || eventIds.length === 0) {
    return [];
  }

  try {
    console.log(`[eventService] Récupération de ${eventIds.length} événements via Edge Function`);
    
    // Appel en parallèle de la Edge Function pour chaque événement
    const promises = eventIds.map(eventId => getEventById(eventId));
    const results = await Promise.allSettled(promises);

    // Filtrer les résultats réussis et logger les erreurs
    const events = [];
    results.forEach((result, index) => {
      if (result.status === 'fulfilled') {
        events.push(result.value);
      } else {
        console.error(`[eventService] Échec de récupération de l'événement ${eventIds[index]}:`, result.reason);
      }
    });

    console.log(`[eventService] ${events.length}/${eventIds.length} événements récupérés avec succès`);
    return events;
  } catch (error) {
    console.error('[eventService] Erreur lors de la récupération des événements:', error);
    throw error;
  }
};
